import React from 'react'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import { EditorConvertToHTML } from '../myeditor'
import LiveHelpTwoToneIcon from '@material-ui/icons/LiveHelpTwoTone'
import ArrowDropDownCircle from "@material-ui/icons/ArrowDropDownCircle"

export default function ({sectionName, onClick, html, onUpdate, attachment, ...params}){
    return (
        <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ArrowDropDownCircle />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <LiveHelpTwoToneIcon style={{ color: typeof attachment !== 'undefined' ? 'green' : 'gray', }}
                        onClick={onClick}
                    />
                    <h3>{sectionName}</h3>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                    <EditorConvertToHTML 
                        html={html} 
                        update={onUpdate}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </div>
    )
}